<template>
  <div id="notFoundView">Not Found</div>
</template>

<script>
export default {
  name: "NotFoundView",
};
</script>
